<template>
    <div class="workTaskSteps">
        <div class="steps">
            <span v-for="(item,index) in stepsList" :class="{'active':isActiveNums == index}" @click="stepsClick(index)">{{item}}</span>
        </div>
        <div class="stepBox">
            <template v-if="isActiveNums == 0">
                <table class="my_table">
                    <tbody>
                        <tr>
                            <td width="780">实时定位</td>
                            <td>保存的定位</td>
                        </tr>
                        <tr>
                            <td style="padding: 25px">对不起，暂时无法识别您的定位信息，您不在该区域内填写。对不起，根据您的定位信息，您不在该区域内填写。根据您的定位信息，您目前正处于该区域内填写。</td>
                            <td>不在该区域内填写/在该区域内填写</td>
                        </tr>
                    </tbody>
                </table>
                <div class="btns" v-if="btnShow">
                    <el-button @click="holdShow = true">保存</el-button>
                    <el-button @click="isActiveNums = 1">下一步</el-button>
                </div>
            </template>
            <template v-if="isActiveNums == 1">
                <div class="bgCol second">
                    <div class="item">
                        <div class="label">请选择目前该区内作物的物候期:</div>
                        <el-button @click="selectShow = true">选择</el-button>
                    </div>
                    <div class="item files">
                        <div class="label">请上传三张该作物的图片:</div>
                        <el-upload
                                action="https://jsonplaceholder.typicode.com/posts/"
                                list-type="picture-card"
                                :limit="3"
                                :on-preview="handleCropPreview"
                                :on-exceed="handleCropExceed"
                                :on-remove="handleCropRemove">
                            <div class="crop"></div>
                        </el-upload>
                        <el-dialog :visible.sync="dialogCropVisible">
                            <img width="100%" :src="dialogCropImageUrl" alt="">
                        </el-dialog>
                    </div>
                </div>
                <div class="btns" v-if="btnShow">
                    <el-button @click="isActiveNums = 0">上一步</el-button>
                    <el-button @click="holdShow = true">保存</el-button>
                    <el-button @click="isActiveNums = 2">下一步</el-button>
                </div>
            </template>
            <template v-if="isActiveNums == 2">
                <div class="bgCol third">
                    <div class="title">观察植株如下部位及情况</div>
                    <div class="flexBox">
                        <div class="item">
                            <span class="label">根:</span>
                            <div class="input">
                                <el-radio-group v-model="radio1">
                                    <el-radio :label="0">正常</el-radio>
                                    <el-radio :label="1">异常</el-radio>
                                </el-radio-group>
                            </div>
                            <span class="label marL">图片:</span>
                            <el-upload
                                    class="wx_uploader"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :show-file-list="false"
                                    :on-success="handleSuccess1"
                                    :before-upload="beforeUpload">
                                <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                                <div class="crop"></div>
                            </el-upload>
                        </div>
                        <div class="item">
                            <span class="label">花:</span>
                            <div class="input">
                                <el-radio-group v-model="radio1">
                                    <el-radio :label="0">正常</el-radio>
                                    <el-radio :label="1">异常</el-radio>
                                </el-radio-group>
                            </div>
                            <span class="label marL">图片:</span>
                            <el-upload
                                    class="wx_uploader"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :show-file-list="false"
                                    :on-success="handleSuccess1"
                                    :before-upload="beforeUpload">
                                <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                                <div class="crop"></div>
                            </el-upload>
                        </div>
                        <div class="item">
                            <span class="label">茎:</span>
                            <div class="input">
                                <el-radio-group v-model="radio1">
                                    <el-radio :label="0">正常</el-radio>
                                    <el-radio :label="1">异常</el-radio>
                                </el-radio-group>
                            </div>
                            <span class="label marL">图片:</span>
                            <el-upload
                                    class="wx_uploader"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :show-file-list="false"
                                    :on-success="handleSuccess1"
                                    :before-upload="beforeUpload">
                                <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                                <div class="crop"></div>
                            </el-upload>
                        </div>
                        <div class="item">
                            <span class="label">果:</span>
                            <div class="input">
                                <el-radio-group v-model="radio1">
                                    <el-radio :label="0">正常</el-radio>
                                    <el-radio :label="1">异常</el-radio>
                                </el-radio-group>
                            </div>
                            <span class="label marL">图片:</span>
                            <el-upload
                                    class="wx_uploader"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :show-file-list="false"
                                    :on-success="handleSuccess1"
                                    :before-upload="beforeUpload">
                                <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                                <div class="crop" v-else></div>
                            </el-upload>
                        </div>
                        <div class="item">
                            <span class="label">叶:</span>
                            <div class="input">
                                <el-radio-group v-model="radio1">
                                    <el-radio :label="0">正常</el-radio>
                                    <el-radio :label="1">异常</el-radio>
                                </el-radio-group>
                            </div>
                            <span class="label marL">图片:</span>
                            <el-upload
                                    class="wx_uploader"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :show-file-list="false"
                                    :on-success="handleSuccess1"
                                    :before-upload="beforeUpload">
                                <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                                <div class="crop"></div>
                            </el-upload>
                        </div>
                    </div>

                </div>
                <div class="btns" v-if="btnShow">
                    <el-button @click="isActiveNums = 1">上一步</el-button>
                    <el-button @click="holdShow = true">保存</el-button>
                    <el-button @click="isActiveNums = 3">下一步</el-button>
                </div>
            </template>
            <template v-if="isActiveNums == 3">
                <div class="bgCol fourth">
                    <div class="item">
                        <span class="label">观察病虫害情况:</span>
                        <div class="input">
                            <el-radio-group v-model="radio2">
                                <el-radio :label="0">有病虫害</el-radio>
                                <el-radio :label="1">无病虫害</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="item_btn">
                        <el-button class="edit_btn" type="primary" plain size="small">添加</el-button>
                    </div>
                    <el-table :data="tableData_01" class="wx_table" :row-class-name="tableRowClassName">
                        <el-table-column prop="name" label="病虫害名"></el-table-column>
                        <el-table-column prop="imgUrl" label="图片">
                            <template slot-scope="scope">
                                <img :src="scope.row.imgUrl" alt="">
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button class="edit_btn" type="primary" plain size="small" @click="situationShow = true">编辑</el-button>
                                <el-button class="del_btn" type="danger" plain size="small" @click="delShow = true">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="btns" v-if="btnShow">
                    <el-button @click="isActiveNums = 2">上一步</el-button>
                    <el-button @click="holdShow = true">保存</el-button>
                    <el-button @click="isActiveNums = 4">下一步</el-button>
                </div>
            </template>
            <template v-if="isActiveNums == 4">
                <div class="bgCol fifth">
                    <div class="item">
                        <span class="label">观察土壤湿度:</span>
                        <div class="input">
                            <el-radio-group v-model="radio3">
                                <el-radio :label="0">干</el-radio>
                                <el-radio :label="1">正常</el-radio>
                                <el-radio :label="2">湿</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div class="btns" v-if="btnShow">
                    <el-button @click="isActiveNums = 3">上一步</el-button>
                    <el-button @click="holdShow = true">保存</el-button>
                    <el-button @click="isActiveNums = 5">下一步</el-button>
                </div>
            </template>
            <template v-if="isActiveNums == 5">
                <div class="bgCol sixth">
                    <div class="item">
                        <span class="label">任务执行期间有无其它费用支出:</span>
                        <div class="input">
                            <el-radio-group v-model="radio4">
                                <el-radio :label="0">有支出</el-radio>
                                <el-radio :label="1">无支出</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <el-table :data="tableData_02" class="wx_table" :row-class-name="tableRowClassName">
                        <el-table-column prop="cost" label="费用">
                            <template slot-scope="scope">
                                {{scope.row.cost}}元
                            </template>
                        </el-table-column>
                        <el-table-column prop="remarks" label="备注"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button class="edit_btn" type="primary" plain size="small" @click="costShow = true">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="item">
                        <span class="label">任务完成状态:</span>
                        <div class="input">
                            <el-radio-group v-model="radio5">
                                <el-radio :label="0">任务完成</el-radio>
                                <el-radio :label="1">任务取消</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="item">
                        <span class="label">任务备注说明:</span>
                    </div>
                    <el-input class="explain" type="textarea" :autosize="{ minRows: 4}" v-model="explain" placeholder="请输入详细说明"></el-input>
                    <div class="item">
                        <span class="label">任务执行期间天气:</span>
                    </div>
                    <div class="weather">
                        <img src="" alt="">
                    </div>
                </div>
                <div class="btns" v-if="btnShow">
                    <el-button @click="isActiveNums = 4">上一步</el-button>
                    <el-button @click="holdShow = true">保存</el-button>
                </div>
            </template>
        </div>
        <!--        保存弹窗-->
        <WxMessageBox :show="holdShow" @save="holdSave" @canse="holdCanse">
            <div slot="content">
                <div class="word">
                    <p>你是否确定保存目前最新的信息！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--        物候期选择-->
        <WxMessageBox :show="selectShow" @save="selectSave" @canse="selectCanse">
            <div slot="content">
                <div class="wx_form marTop97">
                    <div class="form_item">
                        <span class="label w110">请选择物候期:</span>
                        <div class="input">
                            <el-select v-model="Phenophase" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in PhenophaseOptions"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
        <!--        病虫害情况-->
        <WxMessageBox :show="situationShow" @save="situationSave" @canse="situationCanse">
            <div slot="content">
                <div class="wx_form">
                    <div class="form_item">
                        <span class="label w110">选择病虫害:</span>
                        <div class="input">
                            <el-select v-model="InsectPest" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in InsectPestOptions"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_item flexTop">
                        <span class="label w110">图片上传:</span>
                        <div class="input">
                            <el-upload
                                    class="avatar-uploader"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :show-file-list="false"
                                    :on-success="handleSuccess"
                                    :before-upload="beforeUpload">
                                <img v-if="imgUrl" :src="imgUrl" class="avatar">
                                <div class="unloadIcon"></div>
                            </el-upload>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
        <!--        删除弹窗-->
        <WxMessageBox :show="delShow" @save="delsave" @canse="delcanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--        其他费用支出-->
        <WxMessageBox :show="costShow" @save="costSave" @canse="costCanse">
            <div slot="content">
                <div class="wx_form">
                    <div class="form_item">
                        <span class="label">费用额:</span>
                        <div class="input w100">
                            <el-input v-model="price" size="mini"></el-input>
                        </div>
                        <span class="subLabel">元</span>
                    </div>
                    <div class="form_item">
                        <span class="label">备注:</span>
                        <div class="input">
                            <el-input v-model="remarks" size="mini"></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
        <!--        添加-->
        <WxMessageBox :show="addShow" @save="addSave" @canse="addCanse" width="1000px">
            <div slot="content">
                <div class="wx_form">
                    <div class="form_item">
                        <span class="label w110">选择病虫害:</span>
                        <div class="input">
                            <el-select v-model="InsectPest" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in InsectPestOptions"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_item flexTop">
                        <span class="label w110">图片上传:</span>
                        <div class="input">
                            <el-upload
                                    class="more-uploader"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    list-type="picture-card"
                                    :file-list="pestFileList"
                                    :on-success="handleSuccess"
                                    :before-upload="beforeUpload">
                                <div class="unloadIcon"></div>
                            </el-upload>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "workTaskSteps",
        model: {
            prop: 'isActiveNum'
        },
        props: {
            isActiveNum: {
                type: Number,
                default: 1
            },
            btnShow: {
                type: Boolean,
                default: true
            },
        },
        data(){
            return{
                isActiveNums:this.isActiveNum,
                stepsList:['第一步','第二步','第三步','第四步','第五步','第六步'],
                dialogCropImageUrl: '',
                dialogCropVisible: false,
                radio1:0,
                imgUrl:'',
                imageUrl1:'',
                radio2:'',
                tableData_01:[
                    {name:'XXXXX虫',imgUrl:require('../assets/images/home/list_01.png')},
                    {name:'XXXXX虫',imgUrl:require('../assets/images/home/list_01.png')},
                ],
                radio3:'',
                radio4:'',
                tableData_02:[
                    {cost:'3894',remarks:'买卖支出'},
                    {cost:'9288',remarks:'买卖支出'},
                ],
                radio5:'',
                explain:'',
                holdShow:false,
                selectShow:false,
                Phenophase:'',
                PhenophaseOptions:[],
                situationShow:false,
                delShow:false,
                costShow:false,
                InsectPest:'',
                InsectPestOptions:[],
                price:'',
                remarks:'',
                addShow:true,
                pestFileList:[{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}]
            }
        },
        methods: {
            stepsClick(val){
                this.isActiveNums = val
                this.$emit('stepsClick',val)
            },
            handleCropRemove(file, fileList) {
                console.log(file, fileList);
            },
            handleCropPreview(file) {
                this.dialogCropImageUrl = file.url;
                this.dialogCropVisible = true;
            },
            handleCropExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            handleSuccess(res, file) {
            },
            handleSuccess1(res, file) {
                this.imageUrl1 = URL.createObjectURL(file.raw);
            },
            beforeUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            // 表格斑马纹
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 !== 1) {
                    return 'single-row';
                }else{
                    return 'double-row';
                }
            },
            // 保存弹窗
            holdSave(){
                this.holdShow = false
            },
            holdCanse(){
                this.holdShow = false
            },
            // 物候期选择弹窗
            selectSave(){
                this.selectShow = false
            },
            selectCanse(){
                this.selectShow = false
            },
            // 病虫害情况弹窗
            situationSave(){
                this.situationShow = false
            },
            situationCanse(){
                this.situationShow = false
            },
            // 删除弹窗确定
            delsave(){
                this.delShow = false
            },
            // 删除弹窗取消
            delcanse(){
                this.delShow = false
            },
            // 其他费用支出
            costSave(){
                this.costShow = false
            },
            costCanse(){
                this.costShow = false
            },
            // 添加
            addSave(){
                this.addShow = false
            },
            addCanse(){
                this.addShow = false
            },
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .workTaskSteps{
        .steps{
            padding: 50px 0 35px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                width: 200px;
                height: 50px;
                line-height: 50px;
                background: transparent;
                text-align: center;
                font-size: 20px;
                font-weight: bold;
                color: #2D99FF;
                position: relative;
                border: 1px solid #2D99FF;
                cursor: pointer;
                &+span{
                    margin-left: 59px;
                }
                &:after{
                    content: '';
                    width: 20px;
                    height: 20px;
                    background: url("../assets/images/allow_02.png") no-repeat;
                    background-size: cover;
                    position: absolute;
                    right: -40px;
                    top: 50%;
                    margin-top: -10px;
                }
                &:last-child:after{
                    display: none;
                }
            }
            .active{
                color: #fff;
                background: #2D99FF;
                &:after{
                    content: '';
                    background: url("../assets/images/allow_03.png") no-repeat;
                    background-size: cover;
                }
            }
        }
        .stepBox{
            overflow: hidden;
            .btns{
                padding-top: 33px;
                text-align: center;
                .el-button{
                    width: 134px;
                    height: 40px;
                    line-height: 40px;
                    border: 1px solid #2D99FF;
                    font-size: 18px;
                    color: #2D99FF;
                    border-radius: 0;
                    padding: 0;
                    background-color: transparent;
                    text-align: center;
                }
            }
            .bgCol{
                padding: 33px 55px;
                background: rgba(45, 153, 255, 0.143);
            }
            .second{
                .item{
                    display: flex;
                    align-items: center;
                    .label{
                        width: 315px;
                        font-size: 18px;
                        color: #fff;
                    }
                    .el-button{
                        width: 120px;
                        height: 40px;
                        line-height: 40px;
                        background: #2D99FF;
                        font-size: 18px;
                        color: #fff;
                        border: 0;
                        border-radius: 0;
                        padding: 0;
                    }
                    .el-upload{
                        width: 200px;
                        height: 180px;
                        background: rgba(45, 153, 255, 0.3);
                        border-radius: 0;
                        border: 0;
                        .crop{
                            width: 200px;
                            height: 180px;
                            position: relative;
                            &:before{
                                content: '';
                                width: 70px;
                                height: 65px;
                                background: url("../assets/images/upLoad_04.png") no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -35px;
                                margin-top: -32.5px;
                                z-index: 1;
                            }
                            &:after{
                                content: '';
                                width: 41px;
                                height: 41px;
                                background: url("../assets/images/upLoad_02.png") no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -20.5px;
                                margin-top: -20.5px;
                                z-index: 2;
                            }
                            img{
                                width: 100%;
                            }
                        }
                    }
                    .el-upload-list--picture-card .el-upload-list__item{
                        width: 200px;
                        height: 180px;
                        background: rgba(45, 153, 255, 0.3);
                        border-radius: 0;
                        border: 0;
                    }
                }
                .files{
                    align-items: flex-start;
                    margin-top: 35px;
                }
            }
            .third{
                .title{
                    font-size: 18px;
                    color: #fff;
                    padding-bottom: 17px;
                }
                .flexBox{
                    display: flex;
                    flex-wrap: wrap;
                    .item{
                        display: flex;
                        align-items: flex-start;
                        margin-top: 27px;
                        margin-right: 180px;
                        .label{
                            width: 65px;
                            font-size: 18px;
                            color: #D2E9FF;
                        }
                        .marL{
                            margin-left: 45px;
                        }
                        .wx_uploader{
                            width: 90px;
                            height: 90px;
                            background: rgba(45, 153, 255, 0.3);
                            border-radius: 0;
                            border: 0;
                            .crop{
                                width: 90px;
                                height: 90px;
                                position: relative;
                                &:before{
                                    content: '';
                                    width: 40px;
                                    height: 37px;
                                    background: url("../assets/images/upLoad_03.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -20px;
                                    margin-top: -18.5px;
                                    z-index: 1;
                                }
                                &:after{
                                    content: '';
                                    width: 30px;
                                    height: 30px;
                                    background: url("../assets/images/upLoad_01.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -15px;
                                    margin-top: -15px;
                                    z-index: 2;
                                }
                                img{
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }
            .fourth{
                position: relative;
                .item{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    padding-bottom: 35px;
                    .label{
                        font-size: 18px;
                        color: #FFFFFF;
                        padding-right: 72px;
                    }

                }
                .item_btn{
                    position: absolute;
                    right: 55px;
                    top: 15px;
                    .el-button{
                        width: 200px;
                        height: 50px;
                        line-height: 50px;
                        font-size: 18px;
                    }
                }
                .wx_table{
                    .cell{
                        img{
                            width: 50px;
                            height: 32px;
                        }
                    }
                }
            }
            .fifth{
                .item {
                    display: flex;
                    align-items: center;
                    .label {
                        font-size: 18px;
                        color: #FFFFFF;
                        padding-right: 72px;
                    }
                }
            }
            .sixth{
                .item {
                    display: flex;
                    align-items: center;
                    padding-bottom: 35px;
                    .label {
                        font-size: 18px;
                        color: #FFFFFF;
                        width: 320px;
                    }
                }
                .wx_table{
                    margin-bottom: 35px;
                }
                .explain{
                    margin-bottom: 35px;
                }
                .weather{
                    width: 150px;
                    height: 130px;
                    background: rgba(45, 153, 255, 0.3);
                    img{
                        width: 100%;
                    }
                }
            }
        }
        .avatar-uploader {
            width: 70px;
            height: 70px;
            border-radius: 6px;
            border: 1px solid rgba(45, 153, 255, 0.48);
            margin: 0 auto;
            .el-upload{
                width: 70px;
                height: 70px;
            }
            .unloadIcon {
                width: 70px;
                height: 70px;
                position: relative;
                &:after{
                    content: '';
                    width: 41px;
                    height: 41px;
                    background: url("../assets/images/upLoad_02.png") no-repeat;
                    background-size: cover;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -20.5px;
                    margin-left: -20.5px;
                }
            }
        }
        .more-uploader{
            .el-upload--picture-card{
                width: 70px;
                height: 70px;
            }
            .unloadIcon {
                width: 70px;
                height: 70px;
                position: relative;
                &:after{
                    content: '';
                    width: 41px;
                    height: 41px;
                    background: url("../assets/images/upLoad_02.png") no-repeat;
                    background-size: cover;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -20.5px;
                    margin-left: -20.5px;
                }
            }
        }
    }
</style>
